<template>
  <div v-if="units" class="industury">
    <div class="industury__topbanner">
      <ul v-if="$root.globalData">
        <li>{{$root.globalData.keys.units_text}}</li>
        <span> <DoubleLeftAroow /> </span>
        <li>
          <router-link style="color: white" to="/"> {{$root.globalData.keys.home_index_text}} </router-link>
        </li>
      </ul>
    </div>

    <div class="industury__body w95 margin drRtl">
      <div
        class="industury__rightbox"
        data-aos="fade-left"
        data-aos-duration="2000"
      >
        <IndusturyFilter @changeFilter="getUnits" />
        <!-- <RateFilter /> -->
      </div>

      <div class="industury__leftbox">
        <div class="industuty__setiing__responsive margin w">
          <!-- <div class="industury__btn__setting__responsive">
            <span class="btn__setting">فیلتر کردن <FilterIcon /> </span>
            <span class="active" v-on:click="ShowingCard = false"
              ><MenuIcon1
            /></span>
            <span class="btn__setting">
              ترتیب نمایش <SortResponsiveIcon />
            </span>
          </div> -->
        </div>

        <div class="industury__setting">
          <div class="industury__show__right">
            <!-- <div class="dropdown__btnshow">
              <select name="" id="">
                <option value="ترتیب نمایش">ترتیب نمایش</option>
                <option value="ترتیب نمایش">ترتیب نمایش ۱</option>
                <option value="ترتیب نمایش">ترتیب نمایش ۲</option>
                <option value="ترتیب نمایش">ترتیب نمایش ۳</option>
              </select>
            </div> -->

            <div class="filter__btns">
              <span
                :class="{
                  active: ShowingCard == false,
                  deactive: ShowingCard == true
                }"
                v-on:click="ShowingCard = false"
                ><MenuIcon1
              /></span>
              <span
                class="showcard2"
                :class="{ active: ShowingCard == true }"
                v-on:click="ShowingCard = true"
              >
                <MenuIcon2
              /></span>
            </div>
          </div>

          <div v-if="false" class="industury__show__left">
            <span class="show"> نمایش {{ units.total }} </span>
            <span> از {{ units.total }} مورد </span>
            <!-- <button>مشاهده نقشه</button> -->
          </div>
        </div>
        <template v-if="units">
          <CardBoxShow
            :list="units.data"
            v-if="ShowingCard"
            class="cardboxshow"
            
          />

          <div
            v-else
            class="industury__cards"
            id="cardBox"
           
          >
            <Cardbox
              class="card"
              v-for="(item, index) in units.data"
              :data="item"
              :key="index"
            />
          </div>
        </template>

        <section v-if="units.data != ''" class="pagination__section">
          <pagination
            :router="true"
            :limit="isMobile<768?1:3"
            :data="units"
            @pagination-change-page="getUnits"
            class="justify-content-center"
          >
            <span slot="prev-nav">
              <svg
                class="page-arrow mb-2"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="22"
                height="22"
                viewBox="0 0 226 226"
                style="fill: #000000"
              >
                <g
                  fill="none"
                  fill-rule="nonzero"
                  stroke="none"
                  stroke-width="1"
                  stroke-linecap="butt"
                  stroke-linejoin="miter"
                  stroke-miterlimit="10"
                  stroke-dasharray=""
                  stroke-dashoffset="0"
                  font-family="none"
                  font-weight="none"
                  font-size="none"
                  text-anchor="none"
                  style="mix-blend-mode: normal"
                >
                  <path d="M0,226v-226h226v226z" fill="none"></path>
                  <g fill="#b2b2b2">
                    <path
                      d="M82.80781,169.67656c1.05938,1.05937 2.47187,1.58906 3.70781,1.58906c1.23594,0 2.64844,-0.52969 3.70781,-1.58906l52.96875,-52.96875c2.11875,-2.11875 2.11875,-5.47344 0,-7.41563l-52.96875,-52.96875c-2.11875,-2.11875 -5.47344,-2.11875 -7.41563,0c-2.11875,2.11875 -2.11875,5.47344 0,7.41563l49.26094,49.26094l-49.26094,49.26094c-2.11875,2.11875 -2.11875,5.29688 0,7.41562z"
                    ></path>
                  </g>
                </g>
              </svg>
            </span>
            <span slot="next-nav">
              <svg
                class="page-arrow"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="22"
                height="22"
                viewBox="0 0 226 226"
                style="fill: #000000"
              >
                <g
                  fill="none"
                  fill-rule="nonzero"
                  stroke="none"
                  stroke-width="1"
                  stroke-linecap="butt"
                  stroke-linejoin="miter"
                  stroke-miterlimit="10"
                  stroke-dasharray=""
                  stroke-dashoffset="0"
                  font-family="none"
                  font-weight="none"
                  font-size="none"
                  text-anchor="none"
                  style="mix-blend-mode: normal"
                >
                  <path d="M0,226v-226h226v226z" fill="none"></path>
                  <g fill="#b2b2b2">
                    <path
                      d="M143.19219,56.32344c-2.11875,-2.11875 -5.47344,-2.11875 -7.41563,0l-52.96875,52.96875c-2.11875,2.11875 -2.11875,5.47344 0,7.41562l52.96875,52.96875c1.05937,1.05937 2.47188,1.58906 3.70781,1.58906c1.23594,0 2.64844,-0.52969 3.70781,-1.58906c2.11875,-2.11875 2.11875,-5.47344 0,-7.41563l-49.26094,-49.26094l49.26094,-49.26094c2.11875,-2.11875 2.11875,-5.29687 0,-7.41563z"
                    ></path>
                  </g>
                </g>
              </svg>
            </span>
          </pagination>
        </section>
      </div>
    </div>
    <spiner v-if="loaderShow" />
  </div>
  <loader v-else />
</template>

<script>
import loader from "../components/loader.vue";
import DoubleLeftAroow from "../components/svgs/DoubleLeftAroow.vue";
import IndusturyFilter from "../components/main/IndusturyFilter.vue";
// import RateFilter from "../components/main/RateFilter.vue";
import ArrowDown from "../components/svgs/ArrowDown.vue";
import HamburgetMenuIcon3 from "../components/svgs/HamburgetMenuIcon3.vue";
import HamburgerMenuIcon2 from "../components/svgs/HamburgerMenuIcon2.vue";
import Cardbox from "../components/main/Cardbox.vue";
import MenuIcon1 from "../components/svgs/menuIcon1.vue";
import MenuIcon2 from "../components/svgs/MenuIcon2.vue";
import CardBoxShow from "../components/main/CardBoxShow.vue";
import FilterIcon from "../components/svgs/FilterIcon.vue";
import SortResponsiveIcon from "../components/svgs/SortResponsiveIcon.vue";
import spiner from "@/components/spiner.vue"
export default {
  data() {
    return {
      getUnitsFlag: false,
      cardboxitems: 9,
      loaderShow:false,
      ShowingCard: false,
      selectedOption: {
        categoryIds: [],
        countryIds: [],
        cityIds: [],
        townIds: [],
        provinceIds: []
      }
    };
  },

  methods: {
    cardbox() {
      
      // this.ShowingCard =
    },
    getQuery() {
      let filters = {};
      if (this.$route.query.countryIds) {
        filters.countryIds = this.$route.query.countryIds.split(",");
      }
      if (this.$route.query.categoryIds) {
        filters.categoryIds = this.$route.query.categoryIds.split(",");
      }
      if (this.$route.query.provinceIds) {
        filters.provinceIds = this.$route.query.provinceIds.split(",");
      }
      if (this.$route.query.cityIds) {
        filters.cityIds = this.$route.query.cityIds.split(",");
      }
      if (this.$route.query.townIds) {
        filters.townIds = this.$route.query.townIds.split(",");
      }
      if (this.$route.query.status) {
        filters.status = this.$route.query.status;
      }

      return filters;
    },
    getUnits() {
      this.loaderShow=true;
      this.getUnitsFlag = true;
      let filters = this.getQuery();
      let query = "";
      query += `status=${filters.status ? filters.status : 1}&`;
      if (filters.categoryIds) {
        filters.categoryIds.forEach((id) => {
          query += `categoryIds[]=${id}&`;
        });
      }
      if (filters.provinceIds) {
        filters.provinceIds.forEach((id) => {
          query += `provincesIds[]=${id}&`;
        });
      }
      if (filters.cityIds) {
        filters.cityIds.forEach((id) => {
          query += `cityIds[]=${id}&`;
        });
      }
      if (filters.countryIds) {
        filters.countryIds.forEach((id) => {
          query += `countryIds[]=${id}&`;
        });
      }
      if (filters.townIds) {
        filters.townIds.forEach((id) => {
          query += `townIds[]=${id}&`;
        });
      }
      // query=query.substring(0,query.length-1)
      if (this.$route.query.page) {
        query += `page=${this.$route.query.page}`;
      } else {
        query += `page=1`;
      }
      if (this.$route.query.keyword) {
        query += `&keyword=${this.$route.query.keyword}`;
      }

      this.$axios
        .get("front/allUnits?" + query)
        .then((res) => {
          this.loaderShow=false;
          this.getUnitsFlag = false;

          this.$store.commit("setUnits", res.data.units);
          if (res.data.units.data.length == 0) {
            this.$toast.warning(
              this.$root.globalData?this.$root.globalData.keys.could_not_found_any_unit_with_your_filter:""
            );
          }else{
            document.getElementById('cardBox').scrollIntoView({behavior:'smooth'})
          }
        })
        .catch(() => {
          this.getUnitsFlag = false;
        });
    },
    fillOption() {
      let filters = this.getQuery();

      if (filters.categoryIds) {
        filters.categoryIds.forEach((id) => {
          this.selectedOption.categoryIds.push(id);
        });
      }
      if (filters.provinceIds) {
        filters.provinceIds.forEach((id) => {
          this.selectedOption.provinceIds.push(id);
        });
      }
      if (filters.cityIds) {
        filters.cityIds.forEach((id) => {
          this.selectedOption.cityIds.push(id);
        });
      }
      if (filters.countryIds) {
        filters.countryIds.forEach((id) => {
          this.selectedOption.countryIds.push(id);
        });
      }

      if (filters.townIds) {
        filters.townIds.forEach((id) => {
          this.selectedOption.townIds.push(id);
        });
      }
    }
  },
  components: {
    loader,
    spiner,
    DoubleLeftAroow,
    IndusturyFilter,
    
    ArrowDown,
    HamburgetMenuIcon3,
    HamburgerMenuIcon2,
    Cardbox,
    MenuIcon1,
    MenuIcon2,
    CardBoxShow,
    FilterIcon,
    SortResponsiveIcon
  },
  computed: {
    units() {
      return this.$store.getters.getUnits;
    },
    isMobile(){
      return window.innerWidth<768?true:false;
    }
  },
  mounted() {
    if (this.units == null  || Object.keys(this.$route.query) != 0) {
      // let filter={}
      this.getUnits();
    }else if(this.units.data.length==0){
      this.getUnits();

    }
    this.fillOption();

    // https://gorgon.ir/v1/

    //
  },
  watch: {
    $route: {
      handler(newValue, oldValue) {
        if (JSON.stringify(newValue.query) != JSON.stringify(oldValue.query)) {
          if (this.getUnitsFlag == false) {
            this.getUnits();
          
          }
        }
      }
    }
  },
  
  metaInfo() {
        return { 
            title: "صنایع",
            meta: [
                { name: 'description', content:  'صنایع'},
                { property: 'og:title', content: "صنایع"},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'} 
            ]
        }
    }
};
</script>

<style scoped>
.industury {
  background-color: #f1f0f0;
}
.industury__topbanner {
  width: 100%;
  height: 200px;
  background-image: url(../assets/images/industrybanner.jpg);
  background-color: rgba(0, 0, 0, 0.7);
  background-blend-mode: multiply;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

ul {
  display: flex;
  align-items: center;
  justify-content: center;
}

ul li {
  font-size: 20px;
  cursor: pointer;
}

.industury__body {
  padding: 2rem 0;
  display: grid;
  grid-template-columns: 350px 1fr;
  column-gap: 10px;
}
.industury__rightbox {
  border-left: 1px solid #ccc;
}
.industury__leftbox {
}

.dropdown__btnshow {
  background-color: #fff;
  padding: 10px;
  box-shadow: 0 0 10px gray;
  border-radius: 5px;
  margin: 10px;
  text-align: right;
}

.dropdown__btnshow select {
  width: 170px;
  outline: none;
  font-size: 14px;
}

.dropdown__btnshow select option {
  margin-top: 3rem;
  padding-top: 3rem;
}

.industury__show__right {
  display: flex;
  align-items: center;
}

.filter__btns span {
  cursor: pointer;
  padding: 8px 2px 1px;
  display: inline-block;
  margin: 5px;
  border-radius: 5px;
  background-color: #fff;
}

.active {
  background-color: #0d6efd !important;
}

.sortShowBtn {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.sortshow {
  text-align: right;
}

.industuty__setiing__responsive {
  display: none;
  /* background-color: red; */
  padding: 1rem 0;
  width: 100%;
}
.industuty__setiing__responsive .btn__setting {
  background-color: #fff;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  border-radius: 5px;
  box-shadow: 0 0 10px gray;
  flex-shrink: 1;
  cursor: pointer;
}
.industury__btn__setting__responsive .active {
  cursor: pointer;
  padding: 8px 2px 1px;
  display: inline-block;
  margin: 5px;
  border-radius: 5px;
}
.industury__btn__setting__responsive {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.industury__setting {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.industury__show__left {
  display: flex;
  align-items: center;
}

.industury__show__left button {
  background-color: #fff;
  padding: 10px 1rem;
  margin-right: 1rem;
  border-radius: 5px;
  box-shadow: 0 0 10px gray;
  cursor: pointer;
  font-size: 14px;
}

.industury__show__left p {
  margin-left: 10px;
  color: #0d6efd;
}

.industury__show__left .show {
  color: #0d6efd;
  padding: 5px;
}

.industury__cards {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin: 1rem 0;
}
.card__vertical {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
}

@media only screen and (max-width: 1155px) {
  .industury__topbanner {
    display: none;
  }

  .industury__rightbox {
    border-left: 0px solid transparent;
  }
  .industury__body {
    grid-template-columns: 1fr;
    width: 100%;
  }
}

@media only screen and (max-width: 768px) {
  .industury__setting {
    display: none;
  }
  .industury__cards {
    grid-template-columns: 1fr 1fr;
  }
  .industuty__setiing__responsive {
    display: block;
    width: 95%;
  }
}

@media only screen and (max-width: 430px) {
  .industury__cards {
    margin: 1rem 0;
  }
  .industury__btn__setting__responsive .btn__setting {
    font-size: 11px;
  }

  #cardBox {
  }
}
.active.showcard2 {
  background-color: #0d6efd !important;
}
</style>
<style>
span.showcard2.active svg path {
  fill: white;
}
span.deactive svg path {
  fill: #0d6efd;
}
.industury .card {
  margin-bottom: 0px !important;
}
@media (max-width: 768px) {
  .filterSlider__box {
    display: none;
  }
}
.w95{
  width: 95%;
}
@media only screen and (max-width: 1155px) {
  .industury__body .card {
    width: auto;
    margin-bottom: -10px !important;
  }
  .industury__body .card__title {
    font-size: 16px;
    margin-bottom: 5px;
  }
 .industury__body .card__btn {
    margin:1.5rem 0;
  }
  .industury__body .card__address {
    height: 60px;
  }

  .industury__body .card__address,
  .industury__body .card__tel,
  .industury__body .card__title {
    padding: 0 10px;
  }
  .industury__body .card__img img {
    height: 150px;
  }
  .industury__body .card_link {
    font-size: 12px;
  }
  .industury__body .card__companylogo {
    top: 90px;
  }
  .industuty__setiing__responsive{
    padding:0 !important;
  }
}

</style>
